function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-flash-card-quiz\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.27,37.68H4.77A3.65,3.65,0,0,1,1.12,34V9.9A3.66,3.66,0,0,1,4.77,6.24h14.5A3.66,3.66,0,0,1,22.92,9.9V34A3.65,3.65,0,0,1,19.27,37.68ZM4.77,8.49A1.41,1.41,0,0,0,3.37,9.9V34a1.4,1.4,0,0,0,1.4,1.4h14.5a1.4,1.4,0,0,0,1.4-1.4V9.9a1.41,1.41,0,0,0-1.4-1.41Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12,28.6A6.64,6.64,0,1,1,18.66,22,6.64,6.64,0,0,1,12,28.6Zm0-11A4.39,4.39,0,1,0,16.41,22,4.4,4.4,0,0,0,12,17.57Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.08,29.15a1.13,1.13,0,0,1-.8-.33L13,24.54A1.13,1.13,0,1,1,14.6,23l4.27,4.28a1.12,1.12,0,0,1,0,1.59A1.11,1.11,0,0,1,18.08,29.15Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.43,24.1A1.16,1.16,0,0,1,22,24a1.12,1.12,0,0,1-.53-1.5l5.66-11.74a1.12,1.12,0,0,1,1-.63h0a1.12,1.12,0,0,1,1,.63l5.66,11.74a1.12,1.12,0,0,1-2,1l-4.64-9.63-4.64,9.63A1.13,1.13,0,0,1,22.43,24.1Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3,20.31H24.85a1.13,1.13,0,0,1,0-2.25H31.3a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.34,32.83H21.8a1.13,1.13,0,1,1,0-2.25H35.34a1.41,1.41,0,0,0,1.4-1.41V5a1.4,1.4,0,0,0-1.4-1.4H20.84A1.4,1.4,0,0,0,19.44,5V7.37a1.13,1.13,0,0,1-2.25,0V5a3.66,3.66,0,0,1,3.65-3.65h14.5A3.66,3.66,0,0,1,39,5V29.17A3.66,3.66,0,0,1,35.34,32.83Z",
  fill: "#231f20"
});

function SvgCmsFlashCardQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsFlashCardQuiz;